/* eslint-disable camelcase */
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import useUTMStore from './useUTMStore';

export const useUTMHooks = () => {
  const setUTMParams = useUTMStore((state) => state.setUTMParams);
  const { query } = useRouter();
  const { utm_source, utm_medium, utm_campaign, utm_content } = query;

  useEffect(() => {
    if (
      setUTMParams &&
      (utm_source || utm_medium || utm_campaign || utm_content)
    ) {
      setUTMParams({
        utm_source: utm_source as string,
        utm_medium: utm_medium as string,
        utm_campaign: utm_campaign as string,
        utm_content: utm_content as string
      });
    }
  }, [setUTMParams, utm_source, utm_medium, utm_campaign, utm_content]);
};
